import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@shared/shared.module';
import { ReportComponent } from '@app/main/report/report.component';
import { ReportRoutingModule } from './report-routing.module';
import { ReportSideBarComponent } from './components/report-side-bar/report-side-bar.component';
import { ReportFormComponent } from './components/report-form/report-form.component';
import { ReportHeaderComponent } from './components/report-header/report-header.component';
import { ReportMainInfoComponent } from './components/report-main-info/report-main-info.component';
import { ReportGuidanceComponent } from './components/report-guidance/report-guidance.component';
import { ReportStandardComponent } from './components/report-standard/report-standard.component';
import { ReportReleasedComponent } from './components/report-released/report-released.component';
import { ReportSideInfoComponent } from './components/report-side-info/report-side-info.component';
import { ReportOnePagerComponent } from './components/report-one-pager/report-one-pager.component';
import { ReportSignatureUploadComponent } from './components/report-signature-upload/report-signature-upload.component';
import { ReportLanguageSelectionComponent } from './components/report-language-selection/report-language-selection.component';
import { ReportSectionGuidanceComponent } from './components/report-section-guidance/report-section-guidance.component';

@NgModule({
    declarations: [
        ReportComponent,
        ReportSideBarComponent,
        ReportFormComponent,
        ReportHeaderComponent,
        ReportMainInfoComponent,
        ReportGuidanceComponent,
        ReportStandardComponent,
        ReportReleasedComponent,
        ReportSideInfoComponent,
        ReportOnePagerComponent,
        ReportSignatureUploadComponent,
        ReportLanguageSelectionComponent,
        ReportSectionGuidanceComponent
    ],
    imports: [CommonModule, SharedModule, ReportRoutingModule]
})
export class ReportModule {}
